import { Container } from "react-bootstrap";
import { useLocation,Link, useNavigate } from "react-router-dom";
import Navigation from "../Navbar";
import { MdAddAPhoto } from "react-icons/md";
import { FaHandshake } from "react-icons/fa";
import { RiArrowGoBackLine } from "react-icons/ri";
import { GiCarWheel } from "react-icons/gi";
import { TbSteeringWheel } from "react-icons/tb";
import { FaWhatsapp } from "react-icons/fa";
import { FaPrint } from "react-icons/fa";
import Spinner from "../../Components/Spinner";
import api from "../Api/Api";
import { useContext, useEffect, useState } from "react";
import { UserContext } from '../../context/UserContext';
const Visualizar = () => {
    const location = useLocation();
    const orcamento = location.state;
    const {user} = useContext(UserContext)
    const navigate = useNavigate(); 
    const [ShowLoading, setShowLoading] = useState(false) 
    const [placa, setPlaca] = useState('')
    const [num, setNum] = useState("");
    const [name, setName] = useState("");    
    const [msg, setMsg] = useState(""); 
    const credentials = btoa(`${user.userRest}:${user.passRest}`); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "User-Agent": "PneusBrasil",
        "Accept": "application/json",
        'Authorization': `Basic ${credentials}`
    }     
    interface Itens {
        id: number;
        produto: string;
        prodescricao: string;
        quantidade: number;
        preco: number;
        pco_venda: number;
        pco_avista: number;
        promocao: number;
        autoriza: string;
      }     
    //const itens: Itens[] = [];
    const [_pro, set_Pro] = useState<Itens[]>([]);
    async function Balanceamento() {
            setTimeout(() => {
                    setShowLoading(true)
                    api.get('iniciaServicos?filial='+user.filial+'&Orcamento='+orcamento+'&Mecanico=&Status=3',{headers})
                    .then(response => {
                          if (response.data['info'].length > 0 ){   
                            if(response.data['info'] === 'iniciado'){
                                setShowLoading(false)
                                alert('Ordem de serviço altarada com sucesso!')
                            }  
                            if(response.data['info'] === 'erro'){ 
                                setShowLoading(false)
                                alert('Problema na altaração da ordem de serviço, tente novamente!')               
                            }
                              setShowLoading(false)  
                              //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
                          }else{
                            alert('Problema de conexão, tente novamente!')   
                            setShowLoading(false)
                          }                                   
                    });
              }, 10 );        
    }
    async function Alinhamento() {
        setTimeout(() => {
                setShowLoading(true)
                api.get('iniciaServicos?filial='+user.filial+'&Orcamento='+orcamento+'&Mecanico=&Status=4',{headers})
                .then(response => {
                      if (response.data['info'].length > 0 ){   
                        if(response.data['info'] === 'iniciado'){
                            setShowLoading(false)
                            alert('Ordem de serviço altarada com sucesso!')
                        }  
                        if(response.data['info'] === 'erro'){ 
                            setShowLoading(false)
                            alert('Problema na altaração da ordem de serviço, tente novamente!')               
                        }
                          setShowLoading(false)  
                          //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
                      }else{
                        alert('Problema de conexão, tente novamente!')   
                        setShowLoading(false)
                      }                                   
                });
          }, 10 );        
}    
    async function Finalizar() {
        setTimeout(() => {
            let answer = window.confirm("Deseja realmete finalizar a ordem de serviços --> "+orcamento+" ?");
            if (answer) { 
                setShowLoading(true)
                api.get('iniciaServicos?filial='+user.filial+'&Orcamento='+orcamento+'&Mecanico=&Status=8',{headers})
                .then(response => {
                    if (response.data['info'].length > 0 ){ 
                        console.log("response data codigo ",response.data['codigo'])  
                        if(response.data['info'] === 'iniciado'){
                            setShowLoading(false)
                            alert('Ordem de serviço finalizada com sucesso!')
                            navigate("/entrada"); 
                        }  
                        if(response.data['info'] === 'erro'){ 
                            alert('Problema na altaração da ordem de serviço, '+ response.data['codigo'])  
                            setShowLoading(false)             
                        }
                        setShowLoading(false)  
                        //setInfoveuculo('Placa: ' + placa + ' Modelo: ' + response.data.Dadosveiculo[0]['modelo'] + ' Cor: ' + response.data.Dadosveiculo[0]['cor'])                     
                    }else{
                        alert('Problema de conexão, tente novamente!')   
                        setShowLoading(false)
                    }                                   
                });
            }    
        }, 10 );
      }  
    // useEffect(() => {                   
    // })       
    return (
        <div>
            <Navigation />
            <div className="container-lg">
                <label className="d-flex justify-content-center fs-3 text-primary">Ordem de serviços: {orcamento}</label>
                <div className="d-flex justify-content-center flex-column flex-md-row">
                    <button className="mt-4 me-4"><Link to='/Camera' state={orcamento}> Foto <MdAddAPhoto className="ms-2" size={50} /></Link></button>
                    {/* <button className="mt-4 me-4"><Link to='/Finalizar' state={orcamento}> Finalizar <BsXSquareFill className="ms-2" size={50} /></Link></button> */}
                    <button onClick={Finalizar} className="mt-4 me-4">Finalizar <FaHandshake className="ms-2" size={50} /></button>
                    <button onClick={Balanceamento} className="mt-4 me-4">Enviar para Balanceamento <GiCarWheel className="ms-2" size={50} /></button>
                    <button onClick={Alinhamento} className="mt-4 me-4">Enviar para Alinhamento <TbSteeringWheel className="ms-2" size={50} /></button>
                    <button className="mt-4 me-4"><Link to='/Itensaprovacao' state={orcamento}> Aprovação<FaWhatsapp className="ms-2" size={50} /></Link></button>                    
                    <button className="mt-4 me-4"><Link to='/Orcamento' state={orcamento}> Imprimir<FaPrint className="ms-2" size={50} /></Link></button> 
                    <button className="mt-4 me-4"><Link to='/entrada'> Voltar <RiArrowGoBackLine className="ms-2" size={50} /></Link></button>
                </div>

            </div>
            <Spinner isLoading={ShowLoading} />
        </div>
    )
}

export default Visualizar;